import { workspaceApi } from '../api';
import { createResourceStore } from './createResourceStore';

export const dashboardStore = createResourceStore({
  key: 'workspace-dashboard',
  loader: async () => {
    const res = await workspaceApi.dashboard();
    return res?.data || {};
  },
  ttl: 20000,
});

export const managementWorkspaceStore = createResourceStore({
  key: 'workspace-management',
  loader: async () => {
    const res = await workspaceApi.management();
    return res?.data || {};
  },
  ttl: 20000,
});

export function resetWorkspaceStores() {
  dashboardStore.reset();
  managementWorkspaceStore.reset();
}
